<template>
    <a-row class="mt4">
        <a-row>
            <a-col :span="11">
                <label class="foldBlackText">{{
                    $t('handheldConfiguration.logicSettings')}}</label>
            </a-col>
            <a-col :span="4">
                <label class="foldBlackText">{{
                    $t('handheldConfiguration.use')}}</label>
            </a-col>
            <a-col :span="8"><label class="foldBlackText">{{
                $t('handheldConfiguration.priority')}}</label>
            </a-col>
        </a-row>

        <a-divider style="margin: 0px 0px"/>

        <a-row>
            <a-row class="mt4">
                <a-col :span="11">
                    <label class="foldBlackText">{{
                        $t('handheldConfiguration.lastLocation')}}</label>
                </a-col>
                <a-col :span="4">
                    <a-checkbox v-model="lastLocationFlag"></a-checkbox>
                </a-col>
                <a-col :span="6">
                    <a-select size="small" v-model="lastLocationPriority" @change="lastLocationPriorityChange">
                        <a-select-option :value="i" v-for="i in 7">{{ i }}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>

            <a-row class="mt4">
                <a-col :span="11">
                    <label class="foldBlackText">{{
                        $t('handheldConfiguration.nextEmptyLocation')}}</label>
                </a-col>
                <a-col :span="4">
                    <a-checkbox v-model="nextEmptyLocationFlag"></a-checkbox>
                </a-col>
                <a-col :span="6">
                    <a-select size="small" v-model="nextEmptyLocationPriority" @change="nextEmptyLocationPriorityChange">
                        <a-select-option :value="i" v-for="i in 7">{{ i }}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>


            <a-row class="mt4">
                <a-col :span="11">
                    <label class="foldBlackText">{{
                        $t('handheldConfiguration.pickLocation')}}</label>
                </a-col>
                <a-col :span="4">
                    <a-checkbox v-model="pickLocationFlag"></a-checkbox>
                </a-col>
                <a-col :span="6">
                    <a-select size="small" v-model="pickLocationPriority" @change="pickLocationPriorityChange">
                        <a-select-option :value="i" v-for="i in 7">{{ i }}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>

            <a-row class="mt4">
                <a-col :span="11">
                    <label class="foldBlackText">{{
                        $t('handheldConfiguration.storageLocation')}}</label>
                </a-col>
                <a-col :span="4">
                    <a-checkbox v-model="storageLocationFlag"></a-checkbox>
                </a-col>
                <a-col :span="6">
                    <a-select size="small" v-model="storageLocationPriority" @change="storageLocationPriorityChange">
                        <a-select-option :value="i" v-for="i in 7">{{ i }}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>

            <a-row class="mt4">
                <a-col :span="11">
                    <label class="foldBlackText">{{
                        $t('handheldConfiguration. closeToSameSku')}}</label>
                </a-col>
                <a-col :span="4">
                    <a-checkbox v-model="closeToSameSkuFlag"></a-checkbox>
                </a-col>
                <a-col :span="6">
                    <a-select size="small" v-model="closeToSameSkuPriority" @change="closeToSameSkuPriorityChange">
                        <a-select-option :value="i" v-for="i in 7">{{ i }}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>

            <a-row class="mt4">
                <a-col :span="11">
                    <label class="foldBlackText">{{
                        $t('handheldConfiguration.matchItemType')}}</label>
                </a-col>
                <a-col :span="4">
                    <a-checkbox v-model="matchItemTypeFlag"></a-checkbox>
                </a-col>
                <a-col :span="6">
                    <a-select size="small" v-model="matchItemTypePriority" @change="matchItemTypePriorityChange">
                        <a-select-option :value="i" v-for="i in 7">{{ i }}</a-select-option>
                    </a-select>
                </a-col>
            </a-row>
        </a-row>
    </a-row>
</template>
<script>
    export default {
        props:['setting'],
        data() {
            return {
                lastLocationFlag:this.setting.lastLocationFlag,
                lastLocationPriority:this.setting.lastLocationPriority,
                nextEmptyLocationFlag:this.setting.nextEmptyLocationFlag,
                nextEmptyLocationPriority:this.setting.nextEmptyLocationPriority,
                pickLocationFlag:this.setting.pickLocationFlag,
                pickLocationPriority:this.setting.pickLocationPriority,
                storageLocationFlag:this.setting.storageLocationFlag,
                storageLocationPriority:this.setting.storageLocationPriority,
                closeToSameSkuFlag:this.setting.closeToSameSkuFlag,
                closeToSameSkuPriority:this.setting.closeToSameSkuPriority,
                matchItemTypeFlag:this.setting.matchItemTypeFlag,
                matchItemTypePriority:this.setting.matchItemTypePriority
            }
        },
        watch:{
            lastLocationFlag(val) {
                this.$emit('containerCartonSuggestLocationLastLocationFlagChange',val)
                this.$emit('detailCartonSuggestLocationLastLocationFlagChange',val)
            },
            nextEmptyLocationFlag(val) {
                this.$emit('containerCartonSuggestLocationNextEmptyLocationFlagChange',val)
                this.$emit('detailCartonSuggestLocationNextEmptyLocationFlagChange',val)
            },
            pickLocationFlag(val) {
                this.$emit('containerCartonSuggestLocationPickLocationFlagChange',val)
                this.$emit('detailCartonSuggestLocationPickLocationFlagChange',val)
            },
            storageLocationFlag(val) {
                this.$emit('containerCartonSuggestLocationStorageLocationFlagChange',val)
                this.$emit('detailCartonSuggestLocationStorageLocationFlagChange',val)
            },
            closeToSameSkuFlag(val) {
                this.$emit('containerCartonSuggestLocationCloseToSameSkuFlagChange',val)
                this.$emit('detailCartonSuggestLocationCloseToSameSkuFlagChange',val)
            },
            matchItemTypeFlag(val) {
                this.$emit('containerCartonSuggestLocationMatchItemTypeFlagChange',val)
                this.$emit('detailCartonSuggestLocationMatchItemTypeFlagChange',val)
            },


        },
        methods:{
            lastLocationPriorityChange() {
                this.$emit('containerCartonSuggestLocationLastLocationPriorityChange',this.lastLocationPriority)
                this.$emit('detailCartonSuggestLocationLastLocationPriorityChange',this.lastLocationPriority)
            },
            nextEmptyLocationPriorityChange() {
                this.$emit('containerCartonSuggestLocationNextEmptyLocationPriorityChange',this.nextEmptyLocationPriority)
                this.$emit('detailCartonSuggestLocationNextEmptyLocationPriorityChange',this.nextEmptyLocationPriority)
            },
            pickLocationPriorityChange() {
                this.$emit('containerCartonSuggestLocationPickLocationPriorityChange',this.pickLocationPriority)
                this.$emit('detailCartonSuggestLocationPickLocationPriorityChange',this.pickLocationPriority)
            },
            storageLocationPriorityChange() {
                this.$emit('containerCartonSuggestLocationStorageLocationPriorityChange',this.storageLocationPriority)
                this.$emit('detailCartonSuggestLocationStorageLocationPriorityChange',this.storageLocationPriority)
            },
            closeToSameSkuPriorityChange() {
                this.$emit('containerCartonSuggestLocationCloseToSameSkuPriorityChange',this.closeToSameSkuPriority)
                this.$emit('detailCartonSuggestLocationCloseToSameSkuPriorityChange',this.closeToSameSkuPriority)
            },
            matchItemTypePriorityChange() {
                this.$emit('containerCartonSuggestLocationMatchItemTypePriorityChange',this.matchItemTypePriority)
                this.$emit('detailCartonSuggestLocationMatchItemTypePriorityChange',this.matchItemTypePriority)
            },

        }

    };
</script>